"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SyncMemoryCache = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _MutexMap = require("./MutexMap");
class SyncMemoryCache extends _MutexMap.MutexMap {
  constructor(cacheDuration) {
    super();
    (0, _defineProperty2.default)(this, "store", {});
    this.cacheDuration = cacheDuration;
  }
  getItem(key, updateTime, overrideDuration) {
    let item = this.store[key];
    let duration;
    if (item !== null && item !== void 0 && item.exp) {
      duration = item.exp;
    } else if (overrideDuration) {
      duration = overrideDuration;
    } else {
      duration = this.cacheDuration;
    }
    if (duration > 0 && item && Date.now() - item.t.getTime() > duration) {
      delete this.store[key];
      return null;
    }
    if (updateTime && item) {
      let entry = {
        data: item.data,
        t: new Date()
      };
      if (item.exp) {
        entry.exp = item.exp;
      }
      this.store[key] = entry;
    }
    return item;
  }
  setItem(key, data, forceExpire) {
    let entry = {
      data,
      t: new Date()
    };
    if (forceExpire) {
      entry.exp = forceExpire;
    }
    this.store[key] = entry;
  }

  /**
   * @param key Cache key for the data.
   * @param loader Function that loads the data.
   * @param mutexKey If provided, a mutex is used, keyed by this value. If `true`, the first argument `key` is used as the mutex key.
   * @param overrideDuration If provided, overrides the default cache duration
   */
  async withCache(key, loader, mutexKey, overrideDuration) {
    var _ref;
    let useMutexKey;
    if (mutexKey) {
      if (mutexKey === true) {
        useMutexKey = key;
      } else {
        useMutexKey = mutexKey;
      }
    }
    let release = await ((_ref = useMutexKey ? this.getMutex(useMutexKey) : null) === null || _ref === void 0 ? void 0 : _ref.acquire());
    try {
      let item = this.getItem(key, false, overrideDuration);
      if (!item) {
        let data = await loader();
        this.setItem(key, data);
        return data;
      }
      return item.data;
    } finally {
      if (release) {
        release();
        this.clearMutex(useMutexKey);
      }
    }
  }
}
exports.SyncMemoryCache = SyncMemoryCache;
//# sourceMappingURL=SyncMemoryCache.js.map